import type {RutaProd} from '../../../../runtime/rutas';
export default {ruta:'/sistema/catalogos/categorias',documento:'catalogs',acceso:'sesion',filas:['073'],cita:'Areas/Catalogs/Controllers/CategoriesController.cs:42'} satisfies RutaProd;
